module.exports = __webpack_public_path__ + "img/genre04.b481caf6.jpg";